if (!customElements.get('cinoton-editorial-cards')) {
  customElements.define('cinoton-editorial-cards', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-editorial-track]');
      this.previous = this.querySelector('[data-editorial-prev]');
      this.next = this.querySelector('[data-editorial-next]');
      if (!this.track || !this.previous || !this.next) return;

      this.updateControls = () => {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const overflow = maxScroll >= 2;
        this.previous.hidden = !overflow;
        this.next.hidden = !overflow;
        this.previous.setAttribute('aria-disabled', String(this.track.scrollLeft < 2));
        this.next.setAttribute('aria-disabled', String(this.track.scrollLeft >= maxScroll - 2));
        this.track.tabIndex = overflow ? 0 : -1;
      };
      this.onPrevious = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.previous.addEventListener('click', this.onPrevious);
      this.next.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.updateControls, { passive: true });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.updateControls);
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', this.updateControls);
      }
      this.updateControls();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.previous.removeEventListener('click', this.onPrevious);
      this.next.removeEventListener('click', this.onNext);
      this.track.removeEventListener('scroll', this.updateControls);
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.updateControls);
    }

    move(direction) {
      if ((direction < 0 ? this.previous : this.next).getAttribute('aria-disabled') === 'true') return;
      const card = this.track.querySelector('.cinoton-editorial__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
    }
  });
}
